import React from 'react';

/** Trust strip – Forest Cyan. Shown on mobile when hero hides stat cards; or always below hero. */
export default function SectionStats({ content }) {
  const data = content || {};
  const items = Array.isArray(data.items) ? data.items : [];
  if (items.length === 0) return null;

  return (
    <section
      className="lg:hidden border-y py-6 md:py-8"
      style={{ borderColor: 'var(--jb-border)', background: 'var(--jb-forest-bg-2)' }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x gap-0">
          {items.map((item, i) => (
            <div
              key={i}
              className="px-4 py-5 md:py-6 text-center first:border-t-0 md:first:border-t-0 md:first:border-l-0"
              style={{ borderColor: 'var(--jb-border)' }}
            >
              <div className="font-display font-extrabold text-2xl sm:text-3xl text-text-hero">{item.value ?? ''}</div>
              <div className="text-sm text-text-sub mt-1">{item.label ?? ''}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
